import { Box } from "rebass";
import { getLocalizedString } from "../../utils";

const CannotOrderMessage = () => (
  <Box sx={{ textAlign: "start" }}>
    {getLocalizedString("CUSTOMERS_NEW_ORDER_FORBIDDEN")}
    <ul>
      <li>
        -&nbsp;
        {getLocalizedString("CUSTOMERS_NEW_ORDER_FORBIDDEN_2")}
      </li>
      <li>
        -&nbsp;
        {getLocalizedString("CUSTOMERS_NEW_ORDER_FORBIDDEN_3")}
      </li>
    </ul>
  </Box>
);

export default CannotOrderMessage;
